/**
 * example:
 * {
	"messageType": "alertNotification",
	"notificationId": 1645475590082,
	"notificationDetails": {"updateType":"SETUP_TRIGGERED","notificationType":"TRADE_PLAN_UPDATE","TRADE_PLAN":{"type":"RELATED_TRADING_SYSTEMS","id":1,"symbol":"XYZ"}},
	"status": "TACTIC_TRIGGERED",
	"statusDetails": {"pluginTemplate":{"candleDuration":1,"timeUnit":"MINUTES","periodLength":3},"triggerPrice":102.3,"tradeDirection":"LONG","tacticName":"BOUNCE_EMA","symbol":"XYZ"},
	"date": "2022-02-21T15:33:10.488-0500",
	"timestamp": "1645475590491"
}

 * @param {*} pluginTemplate 
 * @returns object with fields:
 * 1) candleDuration
 * 2) periodLength
 * 3) timeUnit
 */
export function bounceEmaParser(pluginTemplate) {
    const parsedObject = {
        candleDuration: null,
        periodLength: null,
        timeUnit: null,
    }
    if(pluginTemplate) {
        parsedObject.candleDuration=pluginTemplate.candleDuration;
        parsedObject.periodLength=pluginTemplate.periodLength;
        parsedObject.timeUnit=pluginTemplate.timeUnit;
    }
    return parsedObject;
}